import { render, staticRenderFns } from "./EditRecruitingProfileBasic.vue?vue&type=template&id=5fc15f4a&scoped=true&"
import script from "./EditRecruitingProfileBasic.vue?vue&type=script&lang=ts&"
export * from "./EditRecruitingProfileBasic.vue?vue&type=script&lang=ts&"
import style0 from "./EditRecruitingProfileBasic.vue?vue&type=style&index=0&id=5fc15f4a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc15f4a",
  null
  
)

export default component.exports